export const SchedulesSkeleton = () => {
    return (
        <div className="h-[458px] w-full" data-test-id="schedules-skeleton">
            <div className="mb-3 h-[65px] animate-pulse rounded-2xl bg-ash-dark dark:bg-blue-main"></div>
            <div className="mb-3 h-[65px] animate-pulse rounded-2xl bg-ash-dark dark:bg-blue-main"></div>
            <div className="mb-3 h-[65px] animate-pulse rounded-2xl bg-ash-dark dark:bg-blue-main"></div>
            <div className="mb-3 h-[65px] animate-pulse rounded-2xl bg-ash-dark dark:bg-blue-main"></div>
            <div className="mb-3 h-[65px] animate-pulse rounded-2xl bg-ash-dark dark:bg-blue-main"></div>
        </div>
    );
};
